import { Box, Flex, Heading, Stack, Text } from "@biblioteksentralen/react";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { useSitePalette } from "../../utils/useSitePalette";
import { DefaultContainer } from "../ContentContainer";
import ContactAvatar from "./ContactAvatar";
import { ContactInfo } from "./ContactCard";
import { ResolvedEmployee } from "@libry-content/common";

const EmployeeViewHeader = ({ employee }: { employee: ResolvedEmployee }) => {
  const { ts } = useTranslation();
  const paletteColor = useSitePalette().colors.card;
  return (
    <Box {...paletteColor.css}>
      <DefaultContainer padding="3rem 0">
        <Flex
          gridGap="3rem"
          flexWrap={{ base: "wrap", lg: "nowrap" }}
          justifyContent={{ base: "center", lg: "unset" }}
          paddingX="1rem"
        >
          <Stack alignItems="center" justifyContent="flex-start" width="10rem" gap={4}>
            <ContactAvatar image={employee.image} name={employee.name} size="10rem" resolution={300} fontSize="3xl" />
          </Stack>
          <Stack flexGrow={2} maxWidth="35rem" gap={6}>
            <Stack textAlign={{ base: "center", sm: "unset" }}>
              <Stack gap={1}>
                <Heading fontSize="3xl" as="h1">
                  {employee.name}
                </Heading>
                <Text fontSize="1.1rem" fontWeight="400">
                  {ts(employee.position)}
                </Text>
                {employee.libraries?.map((library) => (
                  <Text key={library?._id} fontWeight="400" fontSize="1.1rem">
                    {ts(library?.name)}
                  </Text>
                ))}
              </Stack>
              <ContactInfo
                email={employee.showEmail ? employee.email : undefined}
                phone={employee.phone}
                contactFormUrl={employee.contactFormUrl}
              />
            </Stack>
          </Stack>
        </Flex>
      </DefaultContainer>
    </Box>
  );
};

export default EmployeeViewHeader;
